module.exports = __webpack_public_path__ + "static/media/stackpath.e201e10f.svg";